module.exports = __webpack_public_path__ + "img/skillset-horizon.c4e94cac.png";